export default __webpack_public_path__ + "a4c7617cbd4084b2dd6d69b884157cd4.svg";